const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Sushant Prabhu | Portfolio",
  description:
    "A Data Science practitioner ,an avid data enthusiast who delivers AI/ML based solutions using SOTA techniques and yearns for learning",
  og: {
    title: "Sushant Portfolio",
    type: "website",
    url: "https://sushantprabhu.netlify.app/",
  },
};

//Home Page with Portfolio Latest Resume
const greeting = {
  title: "Welcome !",
  sub: "Sushant Prabhu",
  logo_name: "Sushant Prabhu",
  resumeLink: "https://drive.google.com/file/d/1CJO-c0gkylGQEdiQnwfEhqx1ea2GEi-G/view?usp=sharing",
};

// home logos
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Github",
      iconifyClassname: "simple-icons:github",
      style: {
        color: "white",
      },
      profileLink: "https://github.com/SUSHANT12PRABHU",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/sushantprabhu121",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/sushantprabhu",
    },
    // {
    //   siteName: "Hackerearth",
    //   iconifyClassname: "simple-icons:hackerearth",
    //   style: {
    //     color: "#323754",
    //   },
    //   profileLink: "https://www.hackerearth.com/@sushantprabhu120398",
    // },
    {
      siteName: "LinkedIn",
      iconifyClassname: "simple-icons:linkedin",
      style: {
        color: "#0077b5",
      },
      profileLink: "https://www.linkedin.com/in/sushant-prabhu/",
    },
    {
      siteName: "Twitter",
      iconifyClassname: "simple-icons:twitter",
      style: {
        color: "#1DA1F2",
      },
      profileLink: "https://twitter.com/SP__init__",
    },
  ],
};

//what i do?
const skills = {
  data: [
    {
      title: "Data Science & Analysis",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production-ready models for various machine learning and statistical use cases",
        "⚡ Experience in working with Time Series Forecasting using SOTA models and NLP projects (Network Embeddings, OpenAI etc)",
        "⚡ Having good hands-on with Data Cleaning, processing & Analysing using Pandas, Numpy , Tableau & PowerBI viz tools",
        "⚡ Experience with Conversational AI assitants (RASA, Amazon Alexa, Google Assistant Dialogflow speech synthesis)",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "logos-python",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "R",
          fontAwesomeClassname: "logos-r-lang",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "logos-pandas-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "NumPy",
          fontAwesomeClassname: "logos-numpy",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Tableau",
          fontAwesomeClassname: "logos-tableau-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Power BI",
          fontAwesomeClassname: "simple-icons:powerbi",
          style: {
            backgroundColor: "transparent",
            color: "#e0a80d",
          },
        },
        {
          skillName: "DBeaver",
          fontAwesomeClassname: "devicon-dbeaver",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Carrot DS",
          fontAwesomeClassname: "twemoji-carrot",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "VS Code",
          fontAwesomeClassname: "devicon-vscode",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Jupyter",
          fontAwesomeClassname: "logos:jupyter",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Box",
          fontAwesomeClassname: "mdi:box",
          style: {
            color: "#0000FF",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "devicon:git",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Zenhub",
          fontAwesomeClassname: "logos:zenhub-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "skill-icons:docker",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Podman",
          fontAwesomeClassname: "devicon:podman",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "logos:kubernetes",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "Web Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive websites using HTML5, CSS3, BootStrap5, ReactJS & NodeJS",
        "⚡ Creating application backend in Python Streamlit , Node & SQL DB",
        "⚡ Having experience in Domain & Hosting using Netlify & Heroku ",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "BootStrap",
          fontAwesomeClassname: "logos-bootstrap",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Jira : Project Tracking",
          fontAwesomeClassname: "logos:jira",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Editing thumbnails and create attractive user interfaces for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Applying Design principles for initial product wireframing",
      ],
      softwareSkills: [
        
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },
        {
          skillName: "Adobe Photoshop",
          fontAwesomeClassname: "simple-icons:adobephotoshop",
          style: {
            color: "#2fa3f7",
          },
        },
        {
          skillName: "Draw.io",
          fontAwesomeClassname: "vscode-icons:file-type-drawio",
          
        },
        {
          skillName: "Canva",
          fontAwesomeClassname: "simple-icons:canva",
          style: {
            color: "#20c4cb",
          },
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using online hosting infrastructure.",
};

//project cards
// colors:[primary,secondary,success,danger,warning,info,light,dark,]
const projectcards = {
  list: [
    {
      title: "AR AI Proactive Alerts",
      img_path: "internship.gif",
      description:
        "Developed and refined Global Dispute and Escalation Prediction AI model with 75%+ F1 score, resulting in improved efficiency for Finance Collectors in resolving payment delays, to deploy on AR Cloud and Engage AR.Leveraged Watsonx.AI Large language models to extract Contract Accounts Receivable terms in hackathon estimated 10M+ impact.",
      tags: [
        {
          lang: "Professional Project",
          color: "#303030",
        },
        {
          lang: "Python",
          color: "#004782",
        },
        {
          lang: "Jupyter",
          color: "#00a100",
        },
        {
          lang: "Machine Learning",
          color: "#3c0095",
        },
        {
          lang: "watsonx.ai",
          color: "#004782",
        },
        {
          lang: "Docker",
          color: "#e0a80d",
        },
        {
          lang: "Carrot Data Science",
          color: "#4257f5",
        },
        {
          lang: "VS Code",
          color: "#ff4b4b",
        },
      ],
      link: "https://www.ibm.com/products/watsonx-ai",
      code: "https://github.com/SUSHANT12PRABHU",
      linkcolor: "white",
    },
    {
      title: "PDF AI - QA Bot",
      img_path: "pdf-llm.png",
      description:
        "The PDF AI Bot is a Streamlit app that integrates Large Language Models, Langchain, and Weaviate vectorstore to interactively answer questions from uploaded PDFs using natural language processing and vector search technology.",
      tags: [
        {
          lang: "Professional Project",
          color: "#303030",
        },
        {
          lang: "OpenAI",
          color: "#05731c",
        },
        {
          lang: "Langchain",
          color: "#00a100",
        },
        {
          lang: "Streamlit",
          color: "#3c0095",
        },
        {
          lang: "Weaviate AI",
          color: "#004782",
        },
        {
          lang: "VS Code",
          color: "#ff4b4b",
        },
        {
          lang: "Huggingface",
          color: "#e0a80d",
        },
      ],
      link: "",
      code: "https://github.com/SUSHANT12PRABHU",
      linkcolor: "white",
    },
    {
      title: "Small2vec",
      img_path: "graph-gesis.gif",
      description:
        "Evaluation of SOTA Graph Embedding methods and applying for Small world networks - DeepWalk, SDNE, VERSE, node2vec etc..",
      tags: [
        {
          lang: "Academic project",
          color: "#303030",
        },
        {
          lang: "Python",
          color: "#004782",
        },
        {
          lang: "PuTTy",
          color: "#820032",
        },
        {
          lang: "Jupyter",
          color: "#00a100",
        },
        {
          lang: "C++",
          color: "#ff4b4b",
        },
        {
          lang: "MATLAB",
          color: "#c47206",
        },
        {
          lang: "GPU Parallel Processing",
          color: "#3c0095",
        },
        {
          lang: "Keras",
          color: "#004782",
        },
      ],
      link: "",
      code: "https://github.com/SUSHANT12PRABHU",
      linkcolor: "white",
    },
    {
      title: "Tick-Tock-Stock",
      img_path: "Tick_Tock_Stock_Thumbnail.png",
      description:
        "Simplified, interactive visualization of the market stocks, tracking real-time data, easy-to-navigate ticker tracker where one can Stalk one's Stocks.",
      tags: [
        {
          lang: "Personal project",
          color: "#004782",
        },
        {
          lang: "Python",
          color: "#8700b0",
        },
        {
          lang: "Yahoo Finance API",
          color: "#303030",
        },
        {
          lang: "BeautifulSoup",
          color: "#3c0095",
        },
        {
          lang: "Power-BI",
          color: "#ff4b4b",
        },
      ],
      link: "",
      code: "https://github.com/SUSHANT12PRABHU",
      linkcolor: "white",
    },
    {
      title: "DrugX",
      img_path: "Gen-2 Runway ML.gif",
      description:
        "Columbia Data Science Dev Hackathon 2023: Led in a team of 4, analyzed contributions to the disparities in serious adverse outcomes of the various drug treatments approved by FDA ( Federal Drug and Food Administration). Specifically, we were curious about certain drugs, the impacts of sex, patient weight, patient onset age, and the drug's route of administration, Learnt about API limits, faced issues in data collection, and scalability, and understood the up-sides of building something that can impact lives.",
      tags: [
        {
          lang: "Academic Project",
          color: "#05731c",
        },
        {
          lang: "Python",
          color: "#004782",
        },
        {
          lang: "Machine Learning",
          color: "#c47206",
        },
        {
          lang: "Tableau",
          color: "#4257f5",
        },
        {
          lang: "Javascript",
          color: "#ff4b4b",
        },
      ],
      link: "https://devpost.com/software/drugx",
      code: "https://github.com/SUSHANT12PRABHU",
      linkcolor: "white",
    },
    {
      title: "NLP Conversational AI Chatbot",
      img_path: "rasa.gif",
      description:
        "A webapp which detects user's conversations and answers business metrics based on realtime input & data research.",
      tags: [
        {
          lang: "Professional Project",
          color: "#05731c",
        },
        {
          lang: "Python",
          color: "#004782",
        },
        {
          lang: "Rasa X",
          color: "#c47206",
        },
        {
          lang: "Tensorflow",
          color: "#4257f5",
        },
        {
          lang: "Javascript",
          color: "#ff4b4b",
        },
      ],
      link: "",
      code: "https://github.com/SUSHANT12PRABHU",
      linkcolor: "white",
    },
    {
      title: "OpenAI powered TL;DR",
      img_path: "TL_DR_Demo.gif",
      description:
        "Streamlit based webapp leveraging the OpenAI API and customizing it, a self serve Realtime QA/Content Generator/Summarizer/Translator app named TL;DR for my use.",
      tags: [
        {
          lang: "Personal project",
          color: "#004782",
        },
        {
          lang: "Python",
          color: "#c47206",
        },
        {
          lang: "OpenAI",
          color: "#c47206",
        },
        {
          lang: "Streamlit",
          color: "#4257f5",
        },
      ],
      link: "",
      code: "https://github.com/SUSHANT12PRABHU",
      linkcolor: "white",
    },
    {
      title: "PRODG & Demand360",
      img_path: "animation_website_design.gif",
      description:
        "One stop tool for Supply chain teams and Go-To-Market unified analytics developed by collaborating with 10+ team members",
      tags: [
        {
          lang: "Professional Project",
          color: "#05731c",
        },
        {
          lang: "Frontend Product Suite",
          color: "#c47206",
        },
        {
          lang: "Machine Learning",
          color: "#3c0095",
        },
        {
          lang: "ASP.NET",
          color: "#ff4b4b",
        },
        {
          lang: "C#",
          color: "#4D0095",
        },
        {
          lang: "Power-BI",
          color: "#00aaBB",
        },
      ],
      link: "",
      code: "",
      linkcolor: "white",
    },
    {
      title: "FORETELL",
      img_path: "prophet_model.gif",
      description:
        "State of the art Time Series Forecasting for Unit Demand Prediction",
      tags: [
        {
          lang: "Professional Project",
          color: "#05731c",
        },
        {
          lang: "R",
          color: "#004782",
        },
        {
          lang: "Python",
          color: "#8700b0",
        },
        {
          lang: "seaborn",
          color: "#c47206",
        },
        {
          lang: "matplotlib",
          color: "#3c0095",
        },
        {
          lang: "ASP.NET",
          color: "#ff4b4b",
        },
        {
          lang: "C#",
          color: "#4D0095",
        },
      ],
      link: "",
      code: "https://github.com/SUSHANT12PRABHU",
      linkcolor: "white",
    },
    
    {
      title: "WAPP LAB Workbench",
      img_path: "animation_website_market_config.gif",
      description:
        "Real-time Competitive benchmarking and enabling pricing strategies driven by a robust Machine Learning Process",
      tags: [
        {
          lang: "Professional Project",
          color: "#05731c",
        },
        {
          lang: "SQL",
          color: "#004782",
        },
        {
          lang: "Python",
          color: "#8700b0",
        },
        {
          lang: "Automation",
          color: "#c47206",
        },
        {
          lang: "ASP.NET",
          color: "#ff4b4b",
        },
        {
          lang: "C#",
          color: "#4D0095",
        },
      ],
      link: "",
      code: "",
      linkcolor: "white",
    },
    {
      title: "50Acre-Kepler",
      img_path: "kepler-mumbai.png",
      description:
      "Visualize Mumbai locations (hexclusters) on Kepler.gl, analyze the apartments by price range, find places in the airport vicinity / sea-facing areas using high-performance web-based application.",
      tags: [
        {
          lang: "Personal project",
          color: "#004782",
        },
        {
          lang: "Python",
          color: "#ff4b4b",
        },
        {
          lang: "Kepler.gl",
          color: "#3c0095",
        },
        {
          lang: "Kaggle/MagicBricks/Uber - Data",
          color: "#8700b0",
        },
        
      ],
      link: "",
      code: "https://github.com/SUSHANT12PRABHU",
      linkcolor: "white",
    },
    
    {
      title: "Dep-AI Chessbot",
      img_path: "depai-chessbot.jpg",
      description:
        "Primitive Chess engine bot-interface created using flask - chessboard.js, chess.js & Python backend",
      tags: [
        {
          lang: "Personal project",
          color: "#004782",
        },
        {
          lang: "Python",
          color: "#8700b0",
        },
        {
          lang: "Flask",
          color: "#c47206",
        },
      ],
      link: "",
      code: "https://github.com/SUSHANT12PRABHU/Dep-AI-Chess-Bot",
      linkcolor: "white",
    },
    
    {
      title: "SuRaAn",
      img_path: "Suraan.png",
      description:
        "An apparel ordering system using in-app O-Auth used to search, customize and purchase clothing using online/COD gateway",
      tags: [
        {
          lang: "Academic project",
          color: "#303030",
        },
        {
          lang: "Java Swings",
          color: "#00aaBB",
        },
      ],
      link: "",
      code: "",
      linkcolor: "white",
    },
    {
      title: "SKUMap-Neural Network",
      img_path: "acti.gif",
      description:
      "Machine Learning solution to classify Software Licenses, given Software Support Descriptions automatically as part of NPI (New Product Intro) process saving 95% time. Experimented with 220+ finetuned Model experiments using LSTM & Neural network based optimized architectures.",
      tags: [
        {
          lang: "Professional Project",
          color: "#05731c",
        },
        {
          lang: "Python",
          color: "#004782",
        },
        {
          lang: "matplotlib",
          color: "#c47206",
        },
        {
          lang: "Streamlit",
          color: "#ff4b4b",
        },
        {
          lang: "Heroku",
          color: "#3c0095",
        },
      ],
      link: "",
      code: "https://github.com/SUSHANT12PRABHU",
      linkcolor: "white",
    },
    
    {
      title: "Trappyy",
      img_path: "trappyy.png",
      description:
        "Go-To Travel planning app that lets you share your travel stories and view other stories to plan your trips accordingly, has helpful features like time/currency converter, restaurant and hotel finder, cab booking etc.",
      tags: [
        {
          lang: "Academic project",
          color: "#303030",
        },
        {
          lang: "Java",
          color: "#00a100",
        },
        {
          lang: "Android Studio",
          color: "#8700b0",
        },
        {
          lang: "Firebase",
          color: "#3c0095",
        },
      ],
      link: "https://github.com/SUSHANT12PRABHU/Trappyy",
      code: "https://github.com/SUSHANT12PRABHU/Trappyy",
      linkcolor: "white",
    },
    {
      title: "Research - IJECE Aug'20",
      img_path: "news.gif",
      description:
        "Predicting Depression using Deep learning and ensemble algorithms on raw twitter data.",
      tags: [
        {
          lang: "Academic Research",
          color: "#303030",
        },
        {
          lang: "Sentiment Analysis",
          color: "#004782",
        },
        {
          lang: "Deep Learning",
          color: "#303030",
        },
        {
          lang: "Twitter API",
          color: "#ff4b4b",
        },
        {
          lang: "NLTK",
          color: "#051c61",
        },
      ],
      link: "http://ijece.iaescore.com/index.php/IJECE/article/view/20973",
      code: "",
      linkcolor: "white",
    },
    {
      title: "Chess Cub",
      img_path: "chess2.png",
      description:
        "Chess Opening based Trivia Game, Google Action developed to challenge the chess enthusiasts skills and test their know-how of the chess openings via a fun based quiz trivia.",
      tags: [
        {
          lang: "Academic project",
          color: "#303030",
        },
        {
          lang: "Google Assistant",
          color: "#4257f5",
        },
      ],
      link: "",
      code: "https://github.com/SUSHANT12PRABHU/Chesscub",
      linkcolor: "white",
    },
    {
      title: "Kaggle",
      img_path: "kaggle.gif",
      description:
        "Global Terror Indexing",
      tags: [
        {
          lang: "Academic project",
          color: "#303030",
        },
        {
          lang: "Data Mining",
          color: "#c47206",
        },
        {
          lang: "Python",
          color: "#ff4b4b",
        },
      ],
      link: "",
      code: "",
      linkcolor: "white",
    },
    
  ],
};

const resumeleft = {
  left: {
    title: ["Experience"],
    data: [
      {
        title: "Senior Data Scientist Intern",
        subtitle: "IBM , New York City, NY, USA",
        date: "July 2023 - August 2023 💎",
        content: [
          "🔹Developed and refined Global Dispute and Escalation Prediction AI models with 75%+ F1 score, resulting in improved efficiency for Finance Collectors in resolving payment delays, to be deployed on AR Cloud",
          "🔹Awarded IBM AI badge, leveraged watsonx.ai Large language models to extract Accounts Receivable Contract terms in watsonx.ai hackathon",
          "➖Tools and Languages - VS Code, Jupyter , Generative AI, Python, Docker",
        ],
      },
      {
        title: "Senior BI Analyst/Data Scientist",
        subtitle: "DELL Technologies, Bangalore, India",
        date: "Dec 2021 - July 2022 💎",
        content: [
          "🔹Developed a Machine Learning solution to classify Software Licenses, given Software Support Descriptions automatically as part of NPI (New Product Intro) process saving 95% time, requiring minimal manual intervention and multi domain - multi use case solution working under Senior Data Scientists in team of 3",
          "🔹Experimented with 220+ finetuned Model experiments using LSTM & Neural network based architectures optimized using Grid Search, Hyperparameter tuning [ReduceLRonPlateau, EarlyStopping] techniques and exposing API for downstream activities (Model Baseline Accuracy of 70% to Best 99% with top 3 recommendations)",
          "🔹Bagged 1st Place for SKU Mapping using AI/ML Techniques project- Ideathon 4.0, 2021 competition organized by DELL competing with various unique ideas from 45+ teams across DELL",
          "➖Tools and Languages - VS Code, Jupyter , AI Acceleration DSX, Python",
          "➖Libraries and Concepts - Word and Character Embedding, LSTM, Keras, Zero-Shot Learning, Multi Class classification, Auto Keras",
          "🔹Engineered and managed a remote, 4-member cross-functional (product, engineering, sales business) team and coordinated with senior developers toward the launch of Demand360 (Suite of Supply and Inventory Management solutions) and ProdG (Product Go-To-Market unified analytics) frontend POC in ~3 months.",
          "🔹Crafted product roadmap from conception to prototype launch driving product vision for 300+ users scaling for 5+ countries, leveraged as the most used tool in CSB President and SVP weekly business reviews.",
          "🔹WAPP Lab Workbench - Optimized real-time Competitive benchmarking and enabling pricing strategies driven by a robust Machine Learning Process increasing process efficiency by 92%.",
          "🔹Advised and guided MBA intern,  on a Portfolio simplification project analyzing critical 5+ business KPIs integrating online analytics, forecasting market trends, and product optimization providing effective pricing recommendations and revising promotional campaigns.",
          "🔹Contributed to workforce efficiency plan by identifying, assessing, and onboarding 2 hires in <2 months.",
        ],
      },
      {
        title: "BI Data Analyst/Data Scientist",
        subtitle: "DELL Technologies, Bangalore, India",
        date: "June 2020 - Nov 2021",
        content: [
          "🔹Expansion of Prescriptive FORETELL 2.0 to different Business Units (BU) and SBU of company and scope to incorporate Automatic Feedback Loop to develop self automated reinforcement learning system. Improved accuracy of model by 10% average at Segment level for NA, EMEA and APJ regions",
          "🔹Ideated, scoped, and automated the current Inventory and Supply Chain CPFR pipeline using SQL on datasets with 5M+ records and performing data visualization, reducing the time spent manually by 80%. Revamped the Inventory and Supply Chain CPFR Replenishment system having Direct Impact on Revenue saving ~$1Million in tracking and subset project for $30Million revenue savings YoY",
          "🔹Spearheaded a team of 3 to develop AI-driven contextual conversational Chatbot for better efficiency in operations, business, pricing, performance, and market insights (on demand analytics tool).Helped develop a personalized Chatbot using Rasa X (Botfront.io)",
          "🔹Ad-hoc : Worked on recommendation system for Product Placement based on competitor configs and market impact",
          "🔹Bagged 1st Place for FORETELL project - DYUTI 10.0, 2020 competition organized by DELL in Innovative Insights category competing among seasonal Data Science teams",
          "🔹Bagged 1st Place for CPFR project - DYUTI 11.0, 2021 competition organized by DELL in Data Diversity category competing among various teams",
          "🔶Applied for Patent - Performance Boosting of Forecasting models through Cascaded Architecture",
          "➖Tools and Languages - VS Code, Jupyter , MS SSMS, MySQL, C# , R , Python, Power BI, Tableau",
        ],
      },
      {
        title: "Business Intelligence Intern (Machine Learning)",
        subtitle: "DELL Technologies, Bangalore, India",
        date: "Jan 2020 - May 2020",
        content: [
          "🔹Created a Clean MaterialUI Design for prototyping and design fixing before production-ready of App - FORETELL 1.0",
          "🔹Built robust Machine Learning engine ‘Foretell 2.0’ using state-of-the-art Time Series Models- ARIMAX, Holtwinters, Neural Networks, Prophet, and cascaded models to predict the Unit Purchase Plan (UPP) demand, solving Overstating (9.5% annual cost) and Understating ($12 more/ box) scenarios having direct dollar impact on DELL’s revenue.",
          "🔹Developed, transformed and hosted UPP Statistical Machine Learning based Forecasting tool 'FORTELL 1.0' to help the business predict the future trends of Products using SOTA ML models (forecasting engine)",
          "🔹Custom Business Override functionality for COVID, Product transitions etc built in tool that allows real time forecasting",
          "🔹Accuracy of model improved by 10% average at Segment level",
          "➖Tools and Languages - MS SSMS, MySQL, C# , Python, R , VBA",
        ],
      },
      {
        title: "NLP Researcher - DAAD WISE Scholar 2019",
        subtitle: "GESIS - Leibniz Institute of Social Sciences, Cologne, Germany",
        date: "May 2019 - July 2019",
        content: [
          "Evaluation of SOTA Graph Embedding methods and Small world networks -",
          "🔹 Implemented software pipeline to generate and evaluate graph embeddings for State of the art ( SOTA ) methods like Deepwalk , LINE , Node2Vec , Struc2Vec , SDNE ,VERSE etc .",
          "🔹 Evaluated the graph embeddings for following graph mining tasks-",
          "1. Network Reconstruction .",
          "2. Link Prediction .",
          "3. Simulation of Agent-based Navigation .",
          "🔹 Learnt & applied various Machine Learning libraries",
          "🔹 Had hands-on with Data Visualization techniques using matplotlib, plotly, streamlit",
          "🔹 Developed easily extendable pipeline for other graph embedding methods and mining tasks.",
          "➖Tools and Languages - Python , PuTTy , Jupyter",
        ],
      },
      {
        title: "Special Project Intern",
        subtitle: "Cisco",
        date: "April 2020 - June 2020",
        content: [
          "Project Name: Network Load Management",
          "Project Details:",
          "🔹 Identified the requirements of E-Commerce Startup medicine delivery company valued at ~$40M .",
          "🔹Develop solutions to handle outgrowing customer demands and site crashes.",
          "🔹Helped CISCO Sales, Product Marketing & Engineering team to work together to understand the problem and articulate multiple solutions.",
          "🔹Proposed solutions to Customer, shortlist best fit solution reducing downtime and deliver solution insights to solve the business problem.",
        ],
      },
      {
        title: "Data Research Analyst",
        subtitle: "KuBiz Capital Pvt Ltd., Mumbai, India",
        date: "May 2018 - June 2018",
        content: [
          "🔹Active involvement in projects and tasks assigned under the Technology department.",
          "🔹Identified different sources of sales and marketing data, cleanse data ,standardize data formats , perform data analysis and compile data visualizations for customer data snapshot.",
          "🔹Designed Loan disbursal recommendation system in Python, using the sales and marketing data. Created a dashboard with compiled data visualizations for different customer data snapshots to derive maximum churn.",
          "🔹Derived valuable insights and solutions for the business problems by using data analysis.",
        ],
      },
      {
        title: "MIT Manipal - Student Researcher",
        subtitle: "Undergraduation Projects/Papers",
        date: "June 2016 - July 2020",
        content: [
          "🔹Trappyy | Android Studio, Java, SQL",
          "  - Programmed a travel guide application, that allows user to share travel stories, view them and plan their trips accordingly.",
          "  - Employed features such as splash & login screen, travel home feed, inhouse currency converter, time zone explorer, QR code scanner, restaurant and hotel finder, cab booking facilities and navigating geolocation of places to visit.",
          "🔹Global Terrorism Analysis | Python",
          "  - Analysed the World Terrorism spread on 180,000+ terrorist attacks (1970 - 2017) around the world and attacks within India, their perpetrators, attacking methods and evaluated its considerable impact on the world’s economy.",
          "  - Experimented model classifiers of predicting possible terrorist outfit behind an attack and inflicted property damage. (Accuracy- Decision Tree Classifier: 82%, Random Forest: 96%, XGBoost: 97%)",
          "🔹Research Paper - Predicting depression using deep learning and ensemble algorithms on raw twitter data",
          "  - Investigated social network and microblogging sites such as Twitter to detect tweets signifying depression, that can result in dire consequences like death, by employing machine learning.",
          "  - Authored and published a paper on the same in the International Journal of Electrical and Computer Engineering (IJECE), August 2020; p-ISSN 2088-8708, e-ISSN 2722-2578.",
          "➖Programming Languages: C, C++, Java, R, Python, MATLAB, HTML/CSS, C#, JavaScript, Shell Scripting.",
          "➖Libraries and Frameworks: NetworkX, TensorFlow, Keras, NumPy, Pandas, Scikit-Learn, Git, SQL, Android, RASA, Plotly, Matplotlib, Linux, Windows, MacOS.",
          "➖Software: Visual Studio, Cisco Packet Tracer, Arduino IDE, Android Studio, Adobe Illustrator, PuTTY, Unity Engine.",
        ],
      }
    ],
  },
};

const resumeright = {
  right: [
    {
      title: ["Education"],
      data: [
        {
          title: "Masters in Data Science",
          subtitle: "Columbia University in the City of New York, New York, USA",
          date: "2022 - 2023",
        content: [
          " Masters Student MS in Data Science (CGPA: 3.75/4) : Coursework in Data Viz, Machine Learning, NLP, Algorithms, Causal Inference, Deep Learning and Finance",
          "🔹 Graduate Teaching Assistant: Supported courses in Applied Machine Learning, Natural Language Processing and Data Science & Computational Thinking Lab",
          "🔹 Graduate Research Assistant (ISERP): Participated in spatial research projects, contributing to data analysis and visualization",
          "🔹 EGSC Data Science Department Representative: Advocated for Data Science students' interests, hosted events, and fostered community among SEAS graduate students",
          "🔹 Executive Board Member - Treasurer: Managed council funds, financial transactions, to ensure financial success of DSISC events",
          "🔹 Professional Development and Leadership (PDL) Fellow, Graduate Assistant Mentor - Laidlaw Scholar",
          "🔹 Non-Academia : Inter Ivy 2023 Best Chess Player on Board, Columbia Chess Team Core Member, Open Chess Tournament WinnerProfessional Development and Leadership (PDL) Fellow, Graduate Assistant Mentor - Laidlaw Scholar, Application Development Initiative (Mentor)",
        ],

        },
        {
          title: "Bachelor of Engineering in Computer Engineering",
          subtitle: "Manipal Institute of Technology, Karnataka, India",
          date: "2016 - 2020",
          content: [" CGPA: 9.65/10",
          "🔹 DAAD WISE Scholar",
          "🔹 Kadambi Scholar",
          "🔹 Invited to MIT Reality Hack 2020 at Massachusetts Institute of Technology,USA to represent MIT Manipal."],
        },
        {
          title: "Higher Secondary Certificate [HSC]",
          subtitle: "Thakur Vidya Mandir Jr. College, Mumbai, India",
          date: "2014 - 2016",
          content: [" Percentage: 88.92%"],
        },
        {
          title: "Secondary School Certificate [SSC]",
          subtitle: "Thakur Vidya Mandir High School , Mumbai, India",
          date: "2014",
          content: [" Percentage: 94.62%"],
        },
      ],
    },
    {
      title: ["Ranks and Achievements"],
      data: [
        {
          title: "Ranks",
          content: [
            "🔸 1st in Computer & Communication Engineering Batch of 2020 (Branch Topper & Diamond Jubilee Scholarship Recipient)",
            "🔸 Awarded Diamond Jubilee Award 2019 for consistent academic performance",
            "🔸 Kadambi Scholarship Award Winner 2020 for excellent academic and extra curricular throughout Manipal University",
            "🔸 Invited for 'Tea with the Director' in recognition of achieving honours and enhancing the reputation of the institute during the years 2016-2019.",
            "🔸 Winner of 1st MIT Chess Championship 2019 among 76 participants.",
            "🔸 Represented Manipal University in All India South Zone Inter University Chess tournament and finished as the 4 th Best Team among 125 teams.",
            "🔸 Part of Chess Team securing Gold Medal in Inter Mahe Collegiate Chess Tournament - 2016,2017 and 2018.",
          ],
        },
        {
          title: "Achievements",
          content: [
            "- Working Committee at IE-CSE & IAESTE Manipal, Management Committee Member at IEEE, Core Committee Member at ACM-MIT (2016-2020); in association with 50+ team members, conducted workshops attended by 1600 students on topics in Computer Science.",
            "- Co-Founder at International Research Mentorship Forum",
            "- Organizer - TechTatva & Revels Annual Technical & Cultural Fest of college",
            "- 4⭐ Silver Badges & Problem Solving at HackerRank/GFG etc ",
            "- Apprenticeship Build for Digital India Trainee by Google",
            "- Campus Ambassador - Coursera 🔹 Helped the Manipal Global MAHE team to achieve the goals and receive the award for “Delivering Best Learning Outcome” in 2018 for meeting and exceeding all global benchmarks used by Coursera to monitor performance.",
          ],
        },
      ],
    },
    {
      title: ["Hobbies"],
      data: [
        {
          title: "Swachh Bharat Mission",
          subtitle: "Gov of India - https://swachhbharat.mygov.in/",
          content: [
            "100 Hours of Swachhata' jointly launched by Ministry of Human Resource Department and Ministry of Drinking Water and Sanitation , Government of India carried out the following activities in and around the villages of Palimar , Karnataka for rural sanitation and promoting cleanliness in the villages .",
            "▪️ Conduct door-to-door meetings to drive behaviour change with respect to sanitation behaviours.",
            "▪️ Organise waste collection drives in households ,common / shared places",
            "▪️ Organise cleaning of streets ,drains and back - alleys through awareness drives.",
            "▪️ Mobilize panchayat and community about the initiative.",
          ],
        },
        {
          title: "International FIDE Chess Player & Part Time Chess Trainer",
          subtitle: "FIDE Rated Chess Player ( ELO - 1599 ) [Online Lichess/Chess.com ~2400] ",
          content: [
            "- Won several accolades during school & college for various DSO, MSSA, State & National level Chess Tournaments.",
            "- Trained over 10+ chess students from basics of chess to obtaining FIDE Classical & Rapid Rating (Age Range - 10 to 30)."
          ],
        },
        {
          title: "Artist / Karate / Vedic Maths & Science / Photographer",
          subtitle: "Social - https://www.instagram.com/_sushantprabhu/",
          content: [
            "🔸 State Level Karate :- (Bronze Medal - KATA)",
            "🔸 Drawing Elementary Grade ( by Government) - B",
            "🔸 Drawing Intermediate Grade (by Government) - A",
            "🔸 National Merit holder in various science and math exams like IMO,NSO, NCO",
          ],
        },
        {
          title: "Google Local Guides Contributor (5+ Million Views , Level 8 - Top 0.31% in the World)",
          subtitle: "https://www.google.com/maps/contrib/112581359773718476013",
          content: [
            "🔸 Local Guides - global community of explorers who write reviews, share photos, answer questions, add or edit places, and check facts on Google Maps.", 
            "🔸 Millions of people rely on such contributions to navigate and explore the world.",
            "🔸 I enjoy being a local guide since years now. Especially the gratitude from people you have helped correcting or adding their business / street is very rewarding.",
          ],
        },
      ],
    },
  ],
};

//certificate cards
const certifications = {
  certifications: [
    {
      title: "Natural Language Processing",
      subtitle: "Dataquest's Data for Social Good Scholarship",
      logo_path: "dataq.PNG",
      certificate_link:
        "https://app.dataquest.io/view_cert/ZSWRGPVXC1A5J8A0TTTL/",
      alt_name: "Dataquest.io",
      color_code: "#000000",
    },
    {
      title: "CCNA - Cisco Certified Network Associate Training Program",
      subtitle: " Cisco ",
      logo_path: "cisco_ccna.jpg",
      certificate_link: "https://drive.google.com/file/d/1kQEWgU7IRtLGpE95uR6ghamsx8aRf7PL/view?usp=sharing",
      alt_name: "Cisco CCNA Program",
      color_code: "#000000",
    },
    {
      title: "Complete Chatbot using Rasa Python NLP",
      subtitle: "Udemy",
      logo_path: "udemy-01.png",
      certificate_link:
        "https://www.udemy.com/course/the-complete-chatbot-course-using-rasa-python-nlp/",
      alt_name: "Udemy Training",
      color_code: "#000000",
    },
    {
      title: "Executive Data Science Capstone",
      subtitle: "John Hopkins University",
      logo_path: "coursera-01.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/PE8SYLS3Y5BP",
      alt_name: "John Hopkins University",
      color_code: "#000000",
    },
    {
      title: "AWS DeepRacer : Driven by Reinforcement Learning",
      subtitle: "Amazon Web Services",
      logo_path: "aws.png",
      certificate_link:
        "https://www.aws.training/Details/eLearning?id=32143",
      alt_name: "AWS DeepRacer",
      color_code: "#000000",
    },
    {
      title: "AWS ML '21, SUSE Cloud '21, Nutanix Hybrid Cloud '20, Bertelsmann Scholarship '19, Intel Edge AI '19",
      subtitle: "Udacity Scholarship",
      logo_path: "udacity.png",
      certificate_link:
        "https://www.udacity.com/",
      alt_name: "Udacity",
      color_code: "#000000",
    },
    {
      title: "Fundamentals of Digital Marketing",
      subtitle: "Google Digital Unlocked",
      logo_path: "google.png",
      certificate_link:
        "https://drive.google.com/file/d/111KU5lujq9MSiay8wpiDWF5EOHSo38CI/view?usp=sharing",
      alt_name: "Google Digital Unlocked",
      color_code: "#000000",
    },
    {
      title: "Data Scientist - Building Web Apps using Shiny in R",
      subtitle: "DataCamp",
      logo_path: "datacamp-01.png",
      certificate_link:
        "https://learn.datacamp.com/courses/case-studies-building-web-applications-with-shiny-in-r",
      alt_name: "DataCamp Training",
      color_code: "#000000",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "contact.jpg",
    description:
      "I am available on almost every social media. Feel free to message me, will reply as soon as possible. I can help you with ML, AI, NLP and also with Chess ;)",
  },
  addressSection: {
    title: "Home Sweet Home Address - Borivali, Mumbai, India",
    subtitle: "Current Address - New York, USA, 10025",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+1 646-384-9828, however emails are quick :)",
  },
};

//contact icons
const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/SUSHANT12PRABHU",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#8f8a8a", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/sushant-prabhu/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link: "https://www.youtube.com/channel/UCntWOMwNI7MvL5KMQ6e-Qnw",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:sushantprabhu120398@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/_sushantprabhu/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  projectsHeader,
  contactPageData,
  projectcards,
  certifications,
  resumeleft,
  resumeright,
};
